<template>
  <div class="search" @touchmove.prevent @mousewheel.prevent>
    <!-- 输入框 -->
    <div class="searchBox">
      <div class="content">
        <div class="input">
          <van-search clearable @clear='clear()' v-model="value" placeholder="请输入选手编号或名称" />
        </div>
        <div class="searchBtn">
          <van-button @click="gotoVote()" type="primary"  :style="{'background':info.setting.color}">搜索</van-button>
        </div>
      </div>
    </div>
    <!-- 关闭按钮 -->
    <div class="close" >
      <van-icon @click='close()' name="close"  />
    </div>
  </div>
</template>

<script>
  import searchMixin from "@/mixins/search.js"
  export default {
    mixins:[searchMixin],
    data(){
      return{
        info:JSON.parse(sessionStorage.getItem('info'))
      }
    }
  }
</script>

<style lang="less" scoped>
.search{
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999999;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: rgba(0, 0, 0, 0.5);
  .searchBox{
    width: 9.2rem;
    height: 6.6666667rem;
    background: url("@/assets/green/search-bg.39aa7a16.png");
    background-size: 100% 100%;
    box-sizing: border-box;
    position: relative;
    .content{
      width: 96%;
      height: 4.8rem;
      background: #f0fffa;
      position: absolute;
      bottom: .2666667rem;
      left: 0;
      right: 0;
      margin: auto;
      .input{
        margin: 1.0666667rem 0 .5333333rem;
        .van-search{
          background: #f0fffa;
        }
      }
      .searchBtn{
        height: .96rem;
        width: 100%;
        padding: 0 12px;
        box-sizing: border-box;
        .van-button{
          width: 100%;
          height: 100%;
          background: linear-gradient(136deg,#00d688 0%,#00d197 100%);
        }
      }
    }
  }
  div.close{
    margin-top: .5333333rem;
    .van-icon-close{
      font-size: .96rem;
      color: #fff;
    }
  }
}
</style>